<template>
  <v-container>
    <div
      data-v-fae5bece
      class="v-card__title headline lighten-2 v-card__title--primary"
      style="padding: 0px"
    >
      <div>Izbor mehanizacije</div>

      <button
        id="closeModalBtn"
        @click.prevent="closeModalInModal_izbor_mehanizacije"
        class="v-btn v-btn--flat white"
      >
        <v-icon>close</v-icon>
      </button>
    </div>

    <div data-v-fae5bece class="spacer"></div>

    <v-form ref="formModal" v-model="validModal" lazy-validation>
      <v-layout row wrap>
        <v-flex xs2 pa-2>
          <v-checkbox
            label="Eksterna mašina"
            v-model="eksterna_masina"
            :checked="eksterna_masina"
            @change="onCheckboxChange2"
            :disabled="!edit"
          ></v-checkbox>
        </v-flex>
        <template v-if="!eksterna_masina">
          <v-flex xs4 pa-2>
            <v-autocomplete
              v-model="mechanization_to_select"
              :items="mechanization_to_items"
              :item-text="getFieldTextMechanization"
              item-value="id"
              label="Mašina"
              persistent-hint
              return-object
              ref="element6"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            xs1
            pa-2
            style="
              padding-top: 20px !important;
              padding-left: 0px !important;
              padding-top: 20px !important;
              max-width: 40px !important;
            "
          >
            <v-icon
              slot="activator"
              @click="otvoriSifarnik"
              style="color: #018389; padding-left: 0px; font-weight: bold"
              title="Dodavanje mašina"
              v-if="edit"
              >add</v-icon
            >
          </v-flex>
        </template>
        <template v-else>
          <v-flex xs4 pa-2>
            <v-text-field
              v-model="external_mechanization"
              label="Eksterna mašina"
              ref="element5"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit"
            ></v-text-field>
          </v-flex>
        </template>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="timeModalNew"
            label="Radnih sati"
            type="number"
            min="0"
            max="60"
            :disabled="!edit"
            @change="proveraVrednosti"
            onkeydown="javascript: return event.keyCode == 69 ? false : true"
          ></v-text-field>
        </v-flex>
        <template v-if="!eksterna_masina">
          <v-flex xs1 pa-2>
            <v-text-field
              v-model="fuel_consumption"
              label="Gorivo"
              type="number"
              suffix="L"
              @change="popuniUkupniTrosakG"
              min="0"
              ref="element7"
              :disabled="!edit"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 pa-2 style="max-width: 13%">
            <v-text-field
              v-model="fuel_price"
              label="Cena goriva"
              type="number"
              suffix="RSD"
              @change="popuniUkupniTrosakM"
              min="0"
              ref="element8"
              :disabled="!edit"
            ></v-text-field>
          </v-flex>
        </template>
        <template v-else>
          <v-flex xs1 pa-2> </v-flex>
          <v-flex xs2 pa-2>
            <v-text-field
              v-model="work_price"
              label="Cena usluge"
              type="number"
              suffix="RSD"
              @change="popuniUkupniTrosakRS"
              min="0"
              ref="element10"
              :disabled="!edit"
            ></v-text-field>
          </v-flex>
        </template>
      </v-layout>

      <v-layout>
        <v-flex xs4 pa-2> </v-flex>
        
        <template v-if="eksterna_masina">
          <v-flex xs1 pa-2> </v-flex>
          <v-flex xs2 pa-2 style="margin-top: 12px; text-align: right">
            <v-chip
              style="
                color: rgba(0, 0, 0, 0.54);
                background: white;
                font: inherit;
                font-size: 14pt;
              "
            >
              Naše gorivo:
            </v-chip>
          </v-flex>
          <v-flex xs1 pa-2>
            <v-text-field
              v-model="fuel_consumption"
              label="Gorivo"
              type="number"
              suffix="L"
              @change="popuniUkupniTrosakG"
              min="0"
              :disabled="!edit"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 pa-2 style="max-width: 13%">
            <v-text-field
              v-model="fuel_price"
              label="Cena goriva"
              type="number"
              suffix="RSD"
              @change="popuniUkupniTrosakM"
              min="0"
              :disabled="!edit"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 pa-2 style="max-width: 12%">
            <v-text-field
              v-model="sum_gorivo"
              label="Gorivo"
              type="number"
              suffix="RSD"
              min="0"
              disabled
            ></v-text-field>
          </v-flex>
        </template>

        <!-- <v-flex xs2 pa-2 style="max-width: 12%">
          <v-text-field
            v-model="sum_coast"
            label="Iznos"
            type="number"
            suffix="RSD"
            min="0"
            disabled
          ></v-text-field>
        </v-flex> -->
      </v-layout>
      <v-layout row wrap>
        <v-flex xs2 pa-2>
          <v-checkbox
            label="Eksterni vozač"
            v-model="eksterni_radnik"
            :checked="eksterni_radnik"
            @change="onCheckboxChange1"
            :disabled="!edit"
          ></v-checkbox>
        </v-flex>
        <template v-if="!eksterni_radnik">
          <v-flex xs4 pa-2 style="max-width: 130%">
            <v-autocomplete
              v-model="employee_to_select"
              :items="employee_to_items"
              :item-text="getFieldText"
              item-value="id"
              label="Vozač"
              persistent-hint
              return-object
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            xs1
            pa-2
            style="
              padding-top: 20px !important;
              padding-left: 0px !important;
              padding-top: 20px !important;
              max-width: 4.7% !important;
            "
          >
            <v-icon
              slot="activator"
              @click="otvoriSifarnikRS"
              style="color: #018389; padding-left: 0px; font-weight: bold"
              title="Dodavanje radnika"
              v-if="edit"
              >add</v-icon
            >
          </v-flex>
          <v-flex xs3 pa-2> </v-flex>
        </template>
        <template v-else>
          <v-flex xs2 pa-2>
            <v-text-field
              v-model="external_first_name"
              label="Ime"
              ref="element4"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-text-field
              v-model="external_last_name"
              label="Prezime"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-text-field
              v-model="external_contact"
              label="Telefon"
              :disabled="!edit"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 pa-2 style="max-width: 13%">
            <v-text-field
              v-model="work_price_external"
              label="Cena usluge"
              type="number"
              suffix="RSD"
              @change="popuniUkupniTrosakVozac"
              min="0"
              ref="element10"
              :disabled="!edit"
            ></v-text-field>
          </v-flex>
        </template>
        <v-flex xs2 pa-2 style="max-width: 12%">
          <v-text-field
            v-model="sum_coast"
            label="Iznos"
            type="number"
            suffix="RSD"
            min="0"
            disabled
            ref="element9"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs10 pa-2>
          <v-text-field
            v-model="opis"
            label="Opis"
            :disabled="!edit"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2 style="max-width: 10%">
          <v-text-field
            v-model="uradjeno"
            label="Urađeno"
            type="number"
            suffix="ha"
            min="0"
            :disabled="!edit || !prikazi_uneto"
          ></v-text-field>
        </v-flex>
        <v-flex
          xs1
          pa-2
          style="
            text-align: right !important;
            padding-right: 20px !important;
            padding-top: 5px !important;
          "
        >
          <v-icon
            slot="activator"
            id="FloatingButton"
            @click="otvoriModal_izabrani_redova"
            title="Dodavanje redova"
          ></v-icon>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs8>
          <v-btn :disabled="!edit" @click="submit" class="AppButtonFilled"
            >Sačuvaj</v-btn
          >
          <v-btn @click="clear" class="AppButtonOutlined" v-if="edit"
            >odustani</v-btn
          >
          <v-btn
            @click="clear"
            class="AppButtonOutlined"
            :disabled="!edit"
            v-else
            style="border: none !important"
            >odustani</v-btn
          >
        </v-flex>
        <v-flex xs1 pa-2>
          <div class="div_prozorce" v-if="broj_sorti !== 0">
            <p class="gornji_text" v-html="broj_sorti"></p>
            <p class="donji_text" v-html="formatTekstaSorta2(broj_sorti)"></p>
          </div>
          <div class="div_prozorce" v-else>
            <p class="gornji_text">-</p>
            <p class="donji_text">sorti</p>
          </div>
        </v-flex>
        <v-flex xs1 pa-2>
          <div class="div_prozorce" v-if="broj_redova !== 0">
            <p class="gornji_text" v-html="broj_redova"></p>
            <p class="donji_text" v-html="formatTekstaRed2(broj_redova)"></p>
          </div>
          <div class="div_prozorce" v-else>
            <p class="gornji_text">-</p>
            <p class="donji_text">redova</p>
          </div>
        </v-flex>
        <v-flex xs1 pa-2>
          <div class="div_prozorce" v-if="broj_kalemova !== 0">
            <p class="gornji_text" v-html="broj_kalemova"></p>
            <p
              class="donji_text"
              v-html="formatTekstaKalem2(broj_kalemova)"
            ></p>
          </div>
          <div class="div_prozorce" v-else>
            <p class="gornji_text">-</p>
            <p class="donji_text"
            v-html="formatTekstaKalem2(0)"></p>
          </div>
        </v-flex>
        <v-flex xs1 pa-2 v-if="1 === 2">
          <template v-if="povrsina > 1000">
            <div class="div_prozorce" v-if="broj_sorti !== 0">
              <p
                class="gornji_text"
                v-html="Math.round(povrsina / 100) / 100"
              ></p>
              <p class="donji_text">ha</p>
            </div>
          </template>
          <template v-else-if="povrsina > 0">
            <div class="div_prozorce" v-if="broj_sorti !== 0">
              <p class="gornji_text" v-html="Math.round(povrsina) / 100"></p>
              <p class="donji_text">ar</p>
            </div>
          </template>
          <template v-else>
            <div class="div_prozorce">
              <p class="gornji_text">-</p>
              <p class="donji_text">ar</p>
            </div>
          </template>
        </v-flex>
      </v-layout>
    </v-form>

    <v-dialog
      v-model="dialogNote_operacije"
      scrollable
      content-class="ModalInModalGrafic"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <VineyardOperation
              @close="handleDataCloseOperacije($event)"
              :operationType="operacija"
            ></VineyardOperation>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote_operacije_rs"
      scrollable
      content-class="ModalInModalGrafic"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <VineyardOperationRS
              @close="handleDataCloseOperacijeRS($event)"
              :operationType="operacija"
            ></VineyardOperationRS>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote_izabrani_redovi"
      scrollable
      content-class="ModalInModalVineyardRows"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <MyComponentVineYardRows
              @newdata="handleDataVineyardRows($event)"
              @close="handleDataCloseVineyardRows($event)"
              :item="edit_item_pom"
              :vineyardId="id_vineyard_pom"
              :ID="ID"
              :plaintObject="objVineyardPlaintPom"
              :vineyardOperationExecution="objVineyardOperationExecutionPom"
              :izmena="edit"
              :tipOperacije="tip_pom"
              :berba_krcenje="berba_krcenje"
            ></MyComponentVineYardRows>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <TokenComponent ref="frmtoken" />
  </v-container>
</template>

        <script>
import { readJSON, daLiJeVinarija } from "../helpers/Functions";
import TokenComponent from "../components/Token";

import VineyardOperation from "../views/MehanizationVinogradi.vue";
import VineyardOperationRS from "../views/EmployeeVinogradi";

import MyComponentVineYardRows from "./VineyardOperationVineYardRowsComponentPom.vue";

export default {
  props: [
    "articleId",
    "ID",
    "plaintObject",
    "vineyardOperationExecution",
    "item",
    "edit",
    "berba",
    "berba_krcenje",
  ],
  name: "VineyardOperationMechanizationsComponent",
  components: {
    TokenComponent,
    VineyardOperation,
    VineyardOperationRS,
    MyComponentVineYardRows,
  },
  data: () => ({
    ID_item: 0,
    eksterni_radnik: false,
    eksterna_masina: false,
    work_price: undefined,
    external_first_name: undefined,
    external_mechanization: undefined,
    external_last_name: undefined,
    external_contact: undefined,
    machine_hours: undefined,
    fuel_consumption: undefined,
    fuel_price: undefined,
    menuModal: "",
    menuModal2: "",
    timeModal: "",
    timeModalNew: undefined,
    menuModal2New: "",
    // duration: undefined,
    dateModal: null,
    // work_valuta: undefined,
    // fuel_valuta: undefined,
    // currency_items: [],
    // currency_fuel_items: [],
    valid: true,
    validModal: true,
    employee_to_items: [],
    mechanization_to_items: [],
    employee_to_select: undefined,
    mechanization_to_select: undefined,
    dateFormattedModal: null,
    pagination: {
      sortBy: "id",
      rowsPerPage: 10000000,
    },
    items_modal_mechanization: [],
    items_modal_mechanization_save: [],
    opis: undefined,
    edit_item: undefined,
    edit_item_pom: undefined,
    eksterna_masina_pom: false,
    eksterni_radnik_pom: false,
    sum_coast: undefined,
    dialogNote_operacije: false,
    dialogNote_operacije_rs: false,
    operacija: undefined,
    sum_gorivo: undefined,
    uradjeno: undefined,
    broj_sorti: 0,
    broj_redova: 0,
    broj_kalemova: 0,
    povrsina: 0,

    pomFromNew: undefined,
    pomToNew: undefined,

    dialogNote_izabrani_redovi: false,
    objVineyardPlaintPom: undefined,
    objVineyardOperationExecutionPom: undefined,
    id_vineyard_pom: undefined,
    objVineyardOperationRows: [],
    tip: "masina",
    tip_pom: undefined,
    work_price_external: undefined,
    prikazi_uneto: true,

tekstBiljka: "",
vinarija: true,
  }),
  methods: {
    proveraVrednosti(e) {
      this.timeModalNew.replace("-", "");
      if (e < 0) {
        alert("Trajanje ne može biti manje od nule.");
        this.timeModalNew = 0;
      }
    },
    otvoriModal_izabrani_redova() {
      this.id_vineyard_pom = this.articleId;
      this.objVineyardOperationExecutionPom = this.vineyardOperationExecution;
      this.objVineyardPlaintPom = this.plaintObject;
      this.edit_item_pom = this.edit_item;
      this.tip_pom = this.tip;

      this.dialogNote_izabrani_redovi = true;
    },
    handleDataVineyardRows: function (e) {
      // this.dialogNote_izabrani_redovi = false;
    },
    handleDataCloseVineyardRows: function (e) {
      this.dialogNote_izabrani_redovi = false;

        this.objVineyardOperationRows = [];
      
        this.objVineyardPlaintPom = undefined;
        this.id_vineyard_pom = undefined;
        

      if(this.ID_item > 0){
        this.objVineyardOperationExecutionPom = undefined;
      }
      this.edit_item_pom = undefined;
        this.tip_pom = undefined;
        

      let pomObj;
      let _this = this;

      let rows = e.rows;
      let blocks = e.blocks;

      this.uradjeno = Math.round(e.povrsina / 100) / 100;

      if (rows.length > 0) this.prikazi_uneto = false;
      else this.prikazi_uneto = true;

      rows.forEach(function (e) {
        // let lokID;

        // lokID = entry.id_pom.split("_")[0];

        if (e.id !== undefined && e.id !== null)
          pomObj = {
            id: e.id,
            executedNumberFrom: e.executedNumberFrom,
            executedNumberTo: e.executedNumberTo,
            vineyardRow: e.vineyardRow,
            description: "",
            grapeVariety: {
              id: e.grapeVariety.id,
            },
            vineyardOperationRowParentId: e.vineyardOperationRowParentId,
            distanceBetweenPlants: e.distanceBetweenPlants,
          };
        else
          pomObj = {
            id: null,
            executedNumberFrom: e.executedNumberFrom,
            executedNumberTo: e.executedNumberTo,
            vineyardRow: e.vineyardRow,
            description: "",
            grapeVariety: {
              id: e.grapeVariety.id,
            },
            vineyardOperationRowParentId: e.vineyardOperationRowParentId,
            distanceBetweenPlants: e.distanceBetweenPlants,
          };

        _this.objVineyardOperationRows.push(pomObj);
      });

      this.objVineyardOperationBlock = blocks;

      this.izracunajMere();

      if (this.edit_item !== undefined) {
        this.getAllSifarnik(this.ID);
      }
    },
    // handleDataCloseVineyardRows: function (e) {
    //   this.dialogNote_izabrani_redovi = false;
    //   this.objVineyardOperationRows = [];
    //   this.objVineyardPlaintPom = undefined;
    //   this.id_vineyard_pom = undefined;
    //   if(this.ID_item > 0){
    //     this.objVineyardOperationExecutionPom = undefined;
    //   }
    //   this.edit_item_pom = undefined;
    //   this.tip_pom = undefined;

    //   let pomObj;
    //   let _this = this;

    //   let rows = e.rows;
    //   let blocks = e.blocks;

    //   // if(e.povrsina !== 0)
    //   this.uradjeno = Math.round(e.povrsina / 100) / 100;

    //   if (rows.length > 0) this.prikazi_uneto = false;
    //   else this.prikazi_uneto = true;

    //   rows.forEach(function (e) {
    //     // let lokID;

    //     // lokID = entry.id_pom.split("_")[0];

    //     if (e.id !== undefined && e.id !== null)
    //       pomObj = {
    //         id: e.id,
    //         executedNumberFrom: e.executedNumberFrom,
    //         executedNumberTo: e.executedNumberTo,
    //         vineyardRow: e.vineyardRow,
    //         description: "",
    //         grapeVariety: {
    //           id: e.grapeVariety.id,
    //         },
    //         vineyardOperationRowParentId: e.vineyardOperationRowParentId,
    //         distanceBetweenPlants: e.distanceBetweenPlants,
    //       };
    //     else
    //       pomObj = {
    //         id: null,
    //         executedNumberFrom: e.executedNumberFrom,
    //         executedNumberTo: e.executedNumberTo,
    //         vineyardRow: e.vineyardRow,
    //         description: "",
    //         grapeVariety: {
    //           id: e.grapeVariety.id,
    //         },
    //         vineyardOperationRowParentId: e.vineyardOperationRowParentId,
    //         distanceBetweenPlants: e.distanceBetweenPlants,
    //       };

    //     _this.objVineyardOperationRows.push(pomObj);
    //   });

    //   this.objVineyardOperationBlock = blocks;

    //   this.izracunajMere();

    //   if (this.edit_item !== undefined) {
    //     this.getAllSifarnik(this.ID);
    //   }
    // },
    izracunajMere() {
      let _this = this;
      var counts = {};
      var rows = {};

      this.broj_kalemova = 0;
      this.povrsina = 0;

      this.objVineyardOperationRows.forEach(function (e) {
        _this.broj_kalemova =
          _this.broj_kalemova +
          Number(e.executedNumberTo - e.executedNumberFrom + 1);

        counts[e.grapeVariety.id] = 1 + (counts[e.grapeVariety.id] || 0);
        rows[e.vineyardRow.id] = 1 + (rows[e.vineyardRow.id] || 0);
        // rows[e.id] = 1 + (rows[e.id] || 0);



        // let distanceBetweenPlants = 0;
        // let pomStr = localStorage.getItem("vinarija");

        // if (pomStr === "alea") distanceBetweenPlants = 0.8;
        // else if (pomStr === "winedb") distanceBetweenPlants = 1.2;

        _this.povrsina =
          _this.povrsina +
          Number(e.vineyardRow.distanceBetweenRows) *
            (e.executedNumberTo - e.executedNumberFrom + 1) *
            Number(e.distanceBetweenPlants !== null && e.distanceBetweenPlants !== undefined ? e.distanceBetweenPlants : 0 );

      });
      
      // if (!this.prikazi_uneto)
        this.uradjeno = Math.round(this.povrsina / 100) / 100;

      this.broj_sorti = Object.keys(counts).length;
      this.broj_redova = Object.keys(rows).length;
    },
    formatTekstaSorta2(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = "sorta";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = "sorte";
      else tekst = "sorti";

      return tekst;
    },
    formatTekstaKalem2(broj) {
      let tekst = "";

      if (this.vinarija){
        if (broj % 10 === 1 && broj !== 11) tekst = "čokot";
        else if (broj === 2 || broj === 3 || broj === 4) tekst = "čokota";
        else tekst = "čokota";
      }
      else {
        if (broj % 10 === 1 && broj !== 11) tekst = "biljka";
        else if (broj === 2 || broj === 3 || broj === 4) tekst = "biljke";
        else tekst = "biljaka";        
      };

      return tekst;
    },
    formatTekstaRed2(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = "red";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = "reda";
      else tekst = "redova";

      return tekst;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    otvoriSifarnik(event) {
      this.operacija = "Naslon";
      this.dialogNote_operacije = true;
    },
    otvoriSifarnikRS(event) {
      this.operacija = "Naslon";
      this.dialogNote_operacije_rs = true;
    },
    handleDataCloseOperacije: function (e) {
      this.getAllMechanization(e.name);
      this.dialogNote_operacije = false;
    },
    handleDataCloseOperacijeRS: function (e) {
      this.getAllEmployees(e.name, e.lastname);
      this.dialogNote_operacije_rs = false;
    },
    closeModalInModal_izbor_mehanizacije() {
      let complex;

      complex = {
        save: this.items_modal_mechanization_save,
        show: this.items_modal_mechanization,
      };

      this.$emit("close", complex);
    },
    convertTimeToMinute(locTime) {
      //let pomArray = locTime.toString().split(":");

      //var minutes = Number(pomArray[0]) * 60 + Number(pomArray[1]);
      var minutes = locTime * 60;

      return minutes;
    },
    onCheckboxChange1(newValue) {
      if (newValue) {
        setTimeout(() => {
          let inputEl = this.$refs.element4.$el.querySelector("input");
          inputEl.select();
        }, 200);
      } else {
        this.work_price_external = undefined;
        this.employee_to_select = undefined;
      }

      if (
        this.fuel_price !== undefined &&
        this.fuel_consumption !== undefined &&
        this.work_price !== undefined
      )
        this.sum_coast =
          Number(this.fuel_price) * Number(this.fuel_consumption) +
          Number(this.work_price) +
          (this.work_price_external !== undefined
            ? Number(this.work_price_external)
            : 0);
      else if (this.work_price !== undefined)
        this.sum_coast =
          Number(this.work_price) +
          (this.work_price_external !== undefined
            ? Number(this.work_price_external)
            : 0);
      else if (
        this.fuel_price !== undefined &&
        this.fuel_consumption !== undefined
      )
        this.sum_coast =
          Number(this.fuel_price) * Number(this.fuel_consumption) +
          (this.work_price_external !== undefined
            ? Number(this.work_price_external)
            : 0);
      else
        this.sum_coast =
          this.work_price_external !== undefined
            ? Number(this.work_price_external)
            : undefined;
    },
    popuniUkupniTrosakRS(e) {
      if (this.fuel_price === undefined || this.fuel_consumption === undefined)
        this.sum_coast =
          Number(e) +
          (this.work_price_external !== undefined
            ? Number(this.work_price_external)
            : 0);
      else if (
        this.fuel_price !== undefined &&
        this.fuel_consumption !== undefined
      )
        this.sum_coast =
          Number(this.fuel_price) * Number(this.fuel_consumption) +
          Number(e) +
          (this.work_price_external !== undefined
            ? Number(this.work_price_external)
            : 0);
      else
        this.sum_coast =
          this.work_price_external !== undefined
            ? Number(this.work_price_external)
            : 0;
    },
    popuniUkupniTrosakVozac(e) {
      if (this.fuel_price === undefined || this.fuel_consumption === undefined)
        this.sum_coast =
          Number(e) +
          (this.work_price !== undefined ? Number(this.work_price) : 0);
      else if (
        this.fuel_price !== undefined &&
        this.fuel_consumption !== undefined
      )
        this.sum_coast =
          Number(this.fuel_price) * Number(this.fuel_consumption) +
          Number(e) +
          (this.work_price !== undefined ? Number(this.work_price) : 0);
    },
    popuniUkupniTrosakM(e) {
      // if (this.eksterna_masina)
      //   this.sum_gorivo =
      //     Number(this.fuel_price) * Number(this.fuel_consumption);

      if (this.work_price === undefined) {
        if (this.fuel_consumption !== undefined)
          this.sum_coast =
            Number(e) * Number(this.fuel_consumption) +
            (this.work_price_external !== undefined
              ? Number(this.work_price_external)
              : 0);
      } else if (this.fuel_consumption !== undefined)
        this.sum_coast =
          Number(this.work_price) +
          Number(e) * Number(this.fuel_consumption) +
          (this.work_price_external !== undefined
            ? Number(this.work_price_external)
            : 0);
      else
        this.sum_coast =
          Number(this.work_price) +
          (this.work_price_external !== undefined
            ? Number(this.work_price_external)
            : 0);

      if (this.eksterna_masina)
        this.sum_gorivo = Number(e) * Number(this.fuel_consumption);
    },
    popuniUkupniTrosakG(e) {
      this.sum_gorivo = Number(this.fuel_price) * Number(this.fuel_consumption);

      if (!this.eksterna_masina) {
        this.sum_coast =
          Number(this.fuel_price) * Number(this.fuel_consumption);
      } else {
        if (this.work_price === undefined) {
          if (this.fuel_price !== undefined)
            this.sum_coast = Number(e) * Number(this.fuel_price);
        } else if (this.fuel_price !== undefined) {
          this.sum_coast =
            Number(this.work_price) + Number(e) * Number(this.fuel_price);
        } else
          this.sum_coast =
            Number(this.fuel_price) * Number(this.fuel_consumption);
      }
    },
    onCheckboxChange2(newValue) {
      if (this.$refs.element5 !== undefined) {
        if (newValue) {
          setTimeout(() => {
            let inputEl = this.$refs.element5.$el.querySelector("input");
            inputEl.select();
          }, 200);
        }
      }

      this.mechanization_to_select = undefined;
      this.fuel_consumption = undefined;
      this.fuel_price = undefined;
      this.sum_coast =
        this.work_price_external !== undefined
          ? Number(this.work_price_external)
          : undefined;
      this.work_price = undefined;
      this.sum_gorivo = undefined;
    },
    editItem(item) {
      this.edit_item = item;
      this.ID_item = item.id;

      if (item.driver === null) this.eksterni_radnik = true;
      else this.eksterni_radnik = false;

      this.eksterni_radnik_pom = this.eksterni_radnik;

      this.objVineyardOperationRows = item.vineyardOperationRows;

      if (item.vineyardOperationRows.length > 0) this.prikazi_uneto = false;
      else this.prikazi_uneto = true;

      

      this.izracunajMere();

      this.employee_to_select = item.driver;
      this.mechanization_to_select = item.mechanization;

      if (item.mechanization === null) this.eksterna_masina = true;
      else this.eksterna_masina = false;

      this.eksterna_masina_pom = this.eksterna_masina;

      this.external_mechanization = item.externalMechanizationName;
      this.external_first_name = item.externalMachinistFirstName;
      this.external_last_name = item.externalMachinistLastName;
      this.external_contact = item.externalMachinistContact;

      // this.machine_hours = item.machineWorkingHours;
      this.timeModalNew = item.machineWorkingHours / 60;

      this.uradjeno = item.executed;

      this.fuel_consumption = item.fuelConsumption;
      this.fuel_price = item.fuelPrice;
      this.work_price_external = item.driverPrice;

      if (item.price !== null) {
        this.sum_coast =
          item.price +
          (item.driverPrice !== null ? Number(item.driverPrice) : 0);
        this.work_price = item.price;

        if (this.fuel_price !== null && this.fuel_consumption !== null) {
          if (this.eksterna_masina) {
            this.sum_gorivo = this.fuel_price * this.fuel_consumption;
            this.sum_coast =
              item.price +
              this.fuel_price * this.fuel_consumption +
              (item.driverPrice !== null ? Number(item.driverPrice) : 0);
          } else {
            this.sum_coast =
              this.fuel_price * this.fuel_consumption +
              (item.driverPrice !== null ? Number(item.driverPrice) : 0);
            // this.work_price = this.fuel_price * this.fuel_consumption;
          }
        }
      } else {
        this.sum_coast =
          this.fuel_price * this.fuel_consumption +
          (item.driverPrice !== null ? Number(item.driverPrice) : 0);
        // this.work_price = this.fuel_price * this.fuel_consumption;
      }

      this.opis = item.description;
    },

    deleteItem(item) {
      if (this.ID !== 0) this.deleteSifarnik(item.id);
      else {
        let ind = 0;

        ind = this.items_modal_mechanization.findIndex((x) => x === item);

        if (ind >= 0) {
          this.items_modal_mechanization.splice(ind, 1);
          this.items_modal_mechanization_save.splice(ind, 1);
        }
      }
    },
    deleteSifarnik(id) {
      this.$http
        .delete(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/mechanization/" +
            id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.getAllSifarnik();
          this.clear();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .delete(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation_execution/mechanization/" +
                        id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.getAllSifarnik();
                      this.clear();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    formatTime(time) {
      let HH = time.split(":")[0];
      let mm = time.split(":")[1];

      return HH + ":" + mm;
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    allowedStep: (m) => m % 5 === 0,
    clear() {
      this.prikazi_uneto = true;

      this.$refs.formModal.reset();

      if (this.$refs.element5 !== undefined) this.$refs.element5.reset();
      if (this.$refs.element6 !== undefined) this.$refs.element6.reset();
      if (this.$refs.element7 !== undefined) this.$refs.element7.reset();
      if (this.$refs.element8 !== undefined) this.$refs.element8.reset();
      if (this.$refs.element9 !== undefined) this.$refs.element9.reset();
      if (this.$refs.element10 !== undefined) this.$refs.element10.reset();

      // this.$refs.element6.reset();

      this.ID_item = 0;

      // this.setDate();

      this.edit_item = undefined;

      this.povrsina = 0;
      this.broj_kalemova = 0;
      this.broj_redova = 0;
      this.broj_sorti = 0;

      this.objVineyardOperationRows = [];
    },
    getAllSifarnik() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/" +
            this.ID, // +
          // "/planting",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.srediObjekat(response.data);
        })
        .catch((e) => {
          // // console.log(e.response);
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation_execution/" +
                        this.ID, // +
                      //"/planting",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.srediObjekat(response.data);
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnik() {
      this.vineyardOperationExecution.vineyardOperationMechanizations =
        this.items_modal_mechanization_save;

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/update",
          this.vineyardOperationExecution,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.getAllSifarnik();
          this.clear();
        })
        .catch((e) => {
          // // console.log(e.response);
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation_execution/update",
                      complexObjectGlobal,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.getAllSifarnik();
                      this.clear();
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getFieldText(item) {
      return `${item.firstName} ${item.lastName}`;
    },
    getFieldTextMechanization(item) {
      return `${item.name} (${item.type})`;
    },
    getAllEmployees(ime, prezime) {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/employee/all/basic",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.employee_to_items = response.data;

          if (ime !== undefined && ime !== null) {
            let index;

            index = this.employee_to_items.findIndex(
              (x) => x.firstName === ime && x.lastName === prezime
            );

            if (index >= 0)
              this.employee_to_select = this.employee_to_items[index];
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/employee/all/basic",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.employee_to_items = response.data;

                      if (ime !== undefined && ime !== null) {
                        let index;

                        index = this.employee_to_items.findIndex(
                          (x) => x.firstName === ime && x.lastName === prezime
                        );

                        if (index >= 0)
                          this.employee_to_select =
                            this.employee_to_items[index];
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllMechanization(naziv) {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/mechanization/all",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.mechanization_to_items = response.data;

          if (naziv !== undefined && naziv !== null) {
            let index;

            index = this.mechanization_to_items.findIndex(
              (x) => x.name === naziv
            );

            if (index >= 0)
              this.mechanization_to_select = this.mechanization_to_items[index];
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/mechanization/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.mechanization_to_items = response.data;

                      if (naziv !== undefined && naziv !== null) {
                        let index;

                        index = this.mechanization_to_items.findIndex(
                          (x) => x.name === naziv
                        );

                        if (index >= 0)
                          this.mechanization_to_select =
                            this.mechanization_to_items[index];
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      let noviObjekat = [];
      let _this = this;

      if (this.$refs.formModal.validate()) {
        if (this.eksterna_masina === undefined) this.eksterna_masina = false;

        if (this.eksterni_radnik === undefined) this.eksterni_radnik = false;

        let complexObject;
        let complexObjectSave;

        let pomMechanization = null;

        if (!this.eksterna_masina) {
          let indPom = -1;
          indPom = this.mechanization_to_items.findIndex(
            (x) => x.id === this.mechanization_to_select
          );

          if (this.mechanization_to_select.id === undefined)
            pomMechanization = {
              id: this.mechanization_to_items[indPom].id,
            };
          else
            pomMechanization = {
              id: this.mechanization_to_select.id,
            };
        }

        let pomEmployee = null;

        if (!this.eksterni_radnik) {
          if (this.employee_to_select !== undefined) {
            let indPom = -1;
            indPom = this.employee_to_items.findIndex(
              (x) => x.id === this.employee_to_select
            );

            if (this.employee_to_select.id === undefined)
              pomEmployee = {
                id: this.employee_to_items[indPom].id,
              };
            else
              pomEmployee = {
                id: this.employee_to_select.id,
              };
          }
        }

        let pomCena = null;
        if (this.work_price !== undefined) pomCena = this.work_price;

        let pomCenaGoriva = null;
        if (this.fuel_price !== undefined) pomCenaGoriva = this.fuel_price;

        if (!this.eksterni_radnik) {
          if (!this.eksterna_masina) {
            complexObjectSave = {
              id: null,
              driver: pomEmployee,
              machineWorkingHours: this.convertTimeToMinute(this.timeModalNew),
              fuelConsumption: this.fuel_consumption,
              fuelPrice: pomCenaGoriva,
              fuelCurrency: {
                id: 1,
              },
              executed: this.uradjeno,
              executedUnit: "ha",
              // price: pomCena,
              currency: {
                id: 1,
              },
              vineyardOperationRows: this.objVineyardOperationRows,
              harvestQuantity: null,
              harvestUnitOfMeasure: null,
              description: this.opis,
              mechanization: pomMechanization,
              externalMechanizationName: null,
              driverPrice:
                this.work_price_external !== undefined
                  ? Number(this.work_price_external)
                  : null,
            };

            complexObject = {
              id: null,
              driver: this.employee_to_select,
              machineWorkingHours: this.convertTimeToMinute(this.timeModalNew),
              fuelConsumption: this.fuel_consumption,
              fuelPrice: pomCenaGoriva,
              fuelCurrency: {
                id: 1,
                mark: "RSD",
              },
              executed: this.uradjeno,
              executedUnit: "ha",
              // price: pomCena,
              currency: {
                id: 1,
                mark: "RSD",
              },
              vineyardOperationRows: this.objVineyardOperationRows,
              harvestQuantity: null,
              harvestUnitOfMeasure: null,
              description: this.opis,
              mechanization: this.mechanization_to_select,
              externalMechanizationName: null,
              driverPrice:
                this.work_price_external !== undefined
                  ? Number(this.work_price_external)
                  : null,
            };
          } else {
            complexObjectSave = {
              id: null,
              driver: pomEmployee,
              machineWorkingHours: this.convertTimeToMinute(this.timeModalNew),
              fuelConsumption: this.fuel_consumption,
              fuelPrice: pomCenaGoriva,
              fuelCurrency: {
                id: 1,
              },
              executed: this.uradjeno,
              executedUnit: "ha",
              price: pomCena,
              currency: {
                id: 1,
              },
              vineyardOperationRows: this.objVineyardOperationRows,
              harvestQuantity: null,
              harvestUnitOfMeasure: null,
              description: this.opis,
              mechanization: null,
              externalMechanizationName: this.external_mechanization,
              driverPrice:
                this.work_price_external !== undefined
                  ? Number(this.work_price_external)
                  : null,
            };

            complexObject = {
              id: null,
              driver: this.employee_to_select,
              machineWorkingHours: this.convertTimeToMinute(this.timeModalNew),
              fuelConsumption: this.fuel_consumption,
              fuelPrice: pomCenaGoriva,
              fuelCurrency: {
                id: 1,
                mark: "RSD",
              },
              executed: this.uradjeno,
              executedUnit: "ha",
              price: pomCena,
              currency: {
                id: 1,
                mark: "RSD",
              },
              vineyardOperationRows: this.objVineyardOperationRows,
              harvestQuantity: null,
              harvestUnitOfMeasure: null,
              description: this.opis,
              mechanization: null,
              externalMechanizationName: this.external_mechanization,
              driverPrice:
                this.work_price_external !== undefined
                  ? Number(this.work_price_external)
                  : null,
            };
          }
        } else {
          if (!this.eksterna_masina) {
            complexObjectSave = {
              id: null,
              driver: null,
              externalMachinistFirstName: this.external_first_name,
              externalMachinistLastName: this.external_last_name,
              externalMachinistContact: this.external_contact,
              machineWorkingHours: this.convertTimeToMinute(this.timeModalNew),
              fuelConsumption: this.fuel_consumption,
              fuelPrice: pomCenaGoriva,
              fuelCurrency: {
                id: 1,
              },
              executed: this.uradjeno,
              executedUnit: "ha",
              // price: pomCena,
              currency: {
                id: 1,
              },
              vineyardOperationRows: this.objVineyardOperationRows,
              harvestQuantity: null,
              harvestUnitOfMeasure: null,
              description: this.opis,
              mechanization: pomMechanization,
              externalMechanizationName: null,
              driverPrice:
                this.work_price_external !== undefined
                  ? Number(this.work_price_external)
                  : null,
            };

            complexObject = {
              id: null,
              driver: null,
              externalMachinistFirstName: this.external_first_name,
              externalMachinistLastName: this.external_last_name,
              externalMachinistContact: this.external_contact,
              machineWorkingHours: this.convertTimeToMinute(this.timeModalNew),
              fuelConsumption: this.fuel_consumption,
              fuelPrice: pomCenaGoriva,
              fuelCurrency: {
                id: 1,
                mark: "RSD",
              },
              executed: this.uradjeno,
              executedUnit: "ha",
              // price: pomCena,
              currency: {
                id: 1,
                mark: "RSD",
              },
              vineyardOperationRows: this.objVineyardOperationRows,
              harvestQuantity: null,
              harvestUnitOfMeasure: null,
              description: this.opis,
              mechanization: this.mechanization_to_select,
              externalMechanizationName: null,
              driverPrice:
                this.work_price_external !== undefined
                  ? Number(this.work_price_external)
                  : null,
            };
          } else {
            complexObjectSave = {
              id: null,
              driver: null,
              externalMachinistFirstName: this.external_first_name,
              externalMachinistLastName: this.external_last_name,
              externalMachinistContact: this.external_contact,
              machineWorkingHours: this.convertTimeToMinute(this.timeModalNew),
              fuelConsumption: this.fuel_consumption,
              fuelPrice: pomCenaGoriva,
              fuelCurrency: {
                id: 1,
              },
              executed: this.uradjeno,
              executedUnit: "ha",
              price: pomCena,
              currency: {
                id: 1,
              },
              vineyardOperationRows: this.objVineyardOperationRows,
              harvestQuantity: null,
              harvestUnitOfMeasure: null,
              description: this.opis,
              mechanization: null,
              externalMechanizationName: this.external_mechanization,
              driverPrice:
                this.work_price_external !== undefined
                  ? Number(this.work_price_external)
                  : null,
            };

            complexObject = {
              id: null,
              driver: null,
              externalMachinistFirstName: this.external_first_name,
              externalMachinistLastName: this.external_last_name,
              externalMachinistContact: this.external_contact,
              machineWorkingHours: this.convertTimeToMinute(this.timeModalNew),
              fuelConsumption: this.fuel_consumption,
              fuelPrice: pomCenaGoriva,
              fuelCurrency: {
                id: 1,
                mark: "RSD",
              },
              executed: this.uradjeno,
              executedUnit: "ha",
              price: pomCena,
              currency: {
                id: 1,
                mark: "RSD",
              },
              vineyardOperationRows: this.objVineyardOperationRows,
              harvestQuantity: null,
              harvestUnitOfMeasure: null,
              description: this.opis,
              mechanization: null,
              externalMechanizationName: this.external_mechanization,
              driverPrice:
                this.work_price_external !== undefined
                  ? Number(this.work_price_external)
                  : null,
            };
          }
        }

        if (this.ID_item !== 0 && this.ID_item !== null) {
          complexObject.id = this.ID_item;
          complexObjectSave.id = this.ID_item;

          let ind = 0;
          ind = this.items_modal_mechanization.findIndex(
            (x) => x.id === this.ID_item
          );

          if (ind >= 0) {
            this.items_modal_mechanization.splice(ind, 1);
            this.items_modal_mechanization_save.splice(ind, 1);
          }

          this.items_modal_mechanization.push(complexObject);
          this.items_modal_mechanization_save.push(complexObjectSave);
        } else if (this.edit_item !== undefined) {
          let ind = 0;

          let _this = this;

          if (!this.eksterna_masina_pom)
            if (!this.eksterni_radnik_pom)
              ind = this.items_modal_mechanization.findIndex(
                (x) =>
                  x.mechanization === _this.edit_item.mechanization &&
                  x.driver === _this.edit_item.driver
              );
            else
              ind = this.items_modal_mechanization.findIndex(
                (x) =>
                  x.mechanization === _this.edit_item.mechanization &&
                  x.externalMachinistFirstName ===
                    _this.edit_item.externalMachinistFirstName &&
                  x.externalMachinistLastName ===
                    this.edit_item.externalMachinistLastName
              );
          else if (!this.eksterni_radnik_pom)
            ind = this.items_modal_mechanization.findIndex(
              (x) =>
                x.externalMechanizationName ===
                  _this.edit_item.externalMechanizationName &&
                x.driver === _this.edit_item.driver
            );
          else
            ind = this.items_modal_mechanization.findIndex(
              (x) =>
                x.externalMechanizationName ===
                  _this.edit_item.externalMechanizationName &&
                x.externalMachinistFirstName ===
                  _this.edit_item.externalMachinistFirstName &&
                x.externalMachinistLastName ===
                  this.edit_item.externalMachinistLastName
            );

          if (ind >= 0) {
            this.items_modal_mechanization.splice(ind, 1);
            this.items_modal_mechanization_save.splice(ind, 1);
          }

          this.items_modal_mechanization.push(complexObject);
          this.items_modal_mechanization_save.push(complexObjectSave);

          this.clear();
        } else {
          this.items_modal_mechanization.push(complexObject);
          this.items_modal_mechanization_save.push(complexObjectSave);

          this.clear();
        }

        if (this.ID !== 0) this.changeSifarnik();
      }
    },
    srediObjekat(val) {
      let _this = this;

      let newArray;
      if (val.vineyardOperationMechanizations !== undefined)
        newArray = val.vineyardOperationMechanizations;
      else if (
        val.vineyardOperationExecution.vineyardOperationMechanizations !==
        undefined
      )
        newArray =
          val.vineyardOperationExecution.vineyardOperationMechanizations;

      this.items_modal_mechanization = [];
      this.items_modal_mechanization_save = [];

      newArray.forEach(function (e) {
        if (typeof e === "object") {
          let complexObject;
          complexObject = {
            id: e.id,
            date: e.date,
            // duration: e.duration,
            driver: e.driver,
            externalMachinistFirstName: e.externalMachinistFirstName,
            externalMachinistLastName: e.externalMachinistLastName,
            externalMachinistContact: e.externalMachinistContact,
            machineWorkingHours: e.machineWorkingHours,
            mechanization: e.mechanization,
            price: e.price,
            // price: e.price,
            currency: e.currency,
            vineyardOperationRows: e.vineyardOperationRows,
            executed: e.executed,
            executedUnit: e.executedUnit,
            harvestQuantity: e.harvestQuantity,
            harvestUnitOfMeasure: e.harvestUnitOfMeasure,
            description: e.description,
            externalMechanizationName: e.externalMechanizationName,
            fuelConsumption: e.fuelConsumption,
            fuelPrice: e.fuelPrice,
            fuelCurrency: e.fuelCurrency,
            driverPrice: e.driverPrice,
          };

          let objEmployee = null;
          if (e.driver !== null)
            objEmployee = {
              id: e.driver.id,
            };

          let objCurrency = null;
          if (e.currency !== null)
            objCurrency = {
              id: e.currency.id,
            };

          let objFuelCurrency = null;
          if (e.fuelCurrency !== null)
            objFuelCurrency = {
              id: e.fuelCurrency.id,
            };

          let objMechanization = null;
          if (e.mechanization !== null)
            objMechanization = {
              id: e.mechanization.id,
            };

          let complexObjectSave;
          complexObjectSave = {
            id: e.id,
            date: e.date,
            // duration: e.duration,
            driver: objEmployee,
            mechanization: objMechanization,
            externalMachinistFirstName: e.externalMachinistFirstName,
            externalMachinistLastName: e.externalMachinistLastName,
            externalMachinistContact: e.externalMachinistContact,
            machineWorkingHours: e.machineWorkingHours,
            price: e.price,
            currency: objCurrency,
            vineyardOperationRows: e.vineyardOperationRows,
            executed: e.executed,
            executedUnit: e.executedUnit,
            harvestQuantity: null,
            harvestUnitOfMeasure: null,
            description: e.description,
            externalMechanizationName: e.externalMechanizationName,
            fuelConsumption: e.fuelConsumption,
            fuelPrice: e.fuelPrice,
            fuelCurrency: objFuelCurrency,
            driverPrice: e.driverPrice,
          };

          _this.items_modal_mechanization.push(complexObject);
          _this.items_modal_mechanization_save.push(complexObjectSave);
        }
      });
    },
  },
  watch: {
    berba_krcenje: function (val) {},
    dateModal(val) {
      this.dateFormattedModal = this.formatDate1(this.dateModal);
    },
    articleId: function (val) {
      this.clear();

      if (val !== undefined && val !== 0) {
        this.getAllEmployees();
        this.getAllMechanization();
      }
    },
    ID: function (val) {},
    vineyardOperationExecution: function (val) {
      this.clear();
    },
    plaintObject: function (val) {
      if (val !== undefined && val !== 0) this.srediObjekat(val);
    },
    item: function (val) {
      if (val !== undefined) this.editItem(val);
      else this.clear();
    },
    edit: function (val) {},
    berba: function (val) {},
  },
  mounted() {
    this.vinarija = daLiJeVinarija();

    if(this.vinarija)
      this.tekstBiljka = "Broj čokota";
    else{
    this.tekstBiljka = "Broj biljaka";
    }
  },
};
</script>

<style lang="scss" scoped>
.addingItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px !important;
}

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

@import "./../assets/sass/parts/modalStyles";

.coupageItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px;
}

#FloatingButton {
  // position: absolute;
  width: 48px;
  height: 48px;
  font-size: 25px;
  border-radius: 50%;

  background-color: #018389;
  background-image: url("../assets/menuIcons/vinograd.svg");
  background-position: center;

  &:active,
  &:focus {
    box-shadow: none;
  }
}
.gornji_text {
  font-size: 18px !important;
  margin: 0px !important;
  padding-top: 10px !important;
  text-align: center;
}

.donji_text {
  font-size: 12px !important;
  text-align: center;
  margin: 0px !important;
  line-height: 0.1 !important;
}
</style>
